<template>
    <div class="DiamondDetail-main" v-show="visible" @click="onComplete('close')">
        <transition name="sideBottom">
            <div class="DiamondDetail-info" v-show="visible" @click.stop>
                <div class="DiamondDetail-info-container">
                    <div class="DiamondDetail-image">
                        <div class="DiamondDetail-image-info">
                            <img v-if="dataItem.fullPath" :src="dataItem.fullPath" class="image-full">
                        </div>
                    </div>
                    <div class="DiamondDetail-text clearfix">
                        <div class="DiamondDetail-text-info">货号：{{dataItem.d_ref || '-'}}</div>
                        <div class="DiamondDetail-text-info">证书：{{dataItem.cert || '-'}}</div>
                    </div>
                    <div class="DiamondDetail-text clearfix">
                        <div class="DiamondDetail-text-info">形状：{{dataItem.cnShape || '-'}}</div>
                        <div class="DiamondDetail-text-info">切工：{{dataItem.cut || '-'}}</div>
                    </div>
                    <div class="DiamondDetail-text clearfix">
                        <div class="DiamondDetail-text-info">重量：{{dataItem.d_size || '-'}}ct</div>
                        <div class="DiamondDetail-text-info">抛光：{{dataItem.polish || '-'}}</div>
                    </div>
                    <div class="DiamondDetail-text clearfix">
                        <div class="DiamondDetail-text-info">颜色：{{dataItem.color || '-'}}</div>
                        <div class="DiamondDetail-text-info">对称：{{dataItem.sym || '-'}}</div>
                    </div>
                    <div class="DiamondDetail-text clearfix">
                        <div class="DiamondDetail-text-info">净度：{{dataItem.clarity || '-'}}</div>
                        <div class="DiamondDetail-text-info">荧光：{{dataItem.flour || '-'}}</div>
                    </div>
                    <div class="DiamondDetail-text clearfix">
                        <div class="DiamondDetail-text-info">台深：{{dataItem.d_depth || '-'}}mm</div>
                        <div class="DiamondDetail-text-info">台宽：{{dataItem.d_table || '-'}}mm</div>
                    </div>
                    <div class="DiamondDetail-text clearfix">
                        <div class="DiamondDetail-text-info">奶色：{{dataItem.milkyText || '-'}}</div>
                        <div class="DiamondDetail-text-info">咖色：{{dataItem.brownessText || '-'}}</div>
                    </div>
                    <div class="DiamondDetail-text clearfix">
                        <div class="DiamondDetail-text-info" v-if="$route.params.Uid != 19">折扣：{{0 - dataItem.disc}}%</div>
                        <div class="DiamondDetail-text-info">证书号：{{dataItem.certno || '-'}}</div>
                    </div>
                </div>
                <div class="DiamondDetail-foot box-shadow clearfix">
                    <div class="DiamondDetail-foot-info" @click="onComplete('car')">加入购物车</div>
                    <div class="DiamondDetail-foot-info active" @click="onComplete('order')">立即下单</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'DiamondDetail',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            item: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        data () {
            return {}
        },
        computed: {
            dataItem () {
                const data = this.item
                const shape = ['ROUND', 'PRINCESS', 'PEAR', 'HEART', 'MARQUISE', 'OVAL', 'EMERALD', 'RADIANT', 'CUSHION', 'TRIANGLE']
                if (data.shape && shape.indexOf(data.shape) > -1) {
                    data.fullPath = '/static/img/' + data.shape.toLowerCase() + '.png'
                }
                if (!data.fullPath) {
                    data.fullPath = '/static/img/other.png'
                }
                if (data.milky && parseInt(data.milky, 10) === 1) {
                    data.milkyText = '有奶'
                } else {
                    data.milkyText = '无奶'
                }
                if (data.browness && parseInt(data.browness, 10) === 1) {
                    data.brownessText = '有咖'
                } else {
                    data.brownessText = '无咖'
                }
                return data
            }
        },
        methods: {
            onComplete (state) {
                this.$emit('onComplete', state)
            },
            goDia (item) {
                this.$router.push({name: 'DiaWeb', query: {cert: item.certno}})
            }
        },
        mounted () {}
    }
</script>
<style scoped>
    .DiamondDetail-main{ position: absolute; left: 0; top: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 12; }
    .DiamondDetail-info{ position: absolute; right:0; top: 18%; width: 40%; background-color: #fff; border-top-left-radius: 20px; border-top-right-radius: 20px; padding: 0 0 140px; }
    .DiamondDetail-foot{ position: absolute; left: 0; bottom: 20px; width: 100%; height: 60px; line-height: 60px; text-align: center; font-size: 20px; background-color: #fff; }
    .DiamondDetail-foot-info{ width: 50%; height: 100%; float: left; }
    .DiamondDetail-foot-info.active{ background-color: #ff410f; color: #fff; }

    .DiamondDetail-info-container{ width: 100%; padding: 0 20px 0; }
    .DiamondDetail-image{ width: 100%; height: 170px; text-align: center; }
    .DiamondDetail-image-info{ display: inline-block; width: 200px; height: 100%; }

    .DiamondDetail-text{ width: 100%; height: 30px; line-height: 30px; font-size:18px; }
    .DiamondDetail-text-info{ float: left; width: 50%; height: 100%; overflow: hidden; }
    .DiamondDetail-price{ width: 100%; height: 0.46rem; text-align: center; line-height: 0.46rem; font-size: 0.28rem; margin-top: 0.46rem; }
    .DiamondDetail-price .price{ font-size: 0.32rem; color: #ff410f; }
    .a-text{ color: #00a0e9; }
</style>



// WEBPACK FOOTER //
// src/public/DiamondDetail.vue